<template>
    <actions-layout-content :title="pageTitle" :iconName="pageIcon">
        <template v-if="!isSubmitted" #subtitle>{{ $t('pages.auth.forgot_password.subtitle') }}</template>

        <template #content>
            <common-content-wrapper :width="isSubmitted ? 'medium' : 'small'">
                <common-content-spacer height="small">
                    <common-message v-if="isSubmitted" type="success">
                        <span>
                            {{ $t('pages.auth.forgot_password.notifications.email_sent') }}
                            <b>{{ submittedEmail }}</b>
                            {{ $t('pages.auth.forgot_password.notifications.with_instructions') }}
                        </span>
                    </common-message>
                    <forgot-password-form v-else @form-submitted="formSubmitted($event)"></forgot-password-form>

                    <common-buttons>
                        <common-button
                            :type="isSubmitted ? 'primary' : 'link'"
                            :route="{ name: RoutesEnum.AUTH.LOGIN }"
                            :label="$t('pages.auth.forgot_password.buttons.back_to_login')"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </common-content-wrapper>
        </template>
    </actions-layout-content>
</template>

<script>
    import ActionsLayoutContent from 'components/layouts/layout-content/ActionsLayoutContent'
    import ForgotPasswordForm from 'components/forms/auth/ForgotPasswordForm'
    import RoutesEnum from 'enums/routes.enum'
    import AuthService from 'services/AuthService'

    export default {
        components: { ActionsLayoutContent, ForgotPasswordForm },

        data: () => ({ RoutesEnum, isSubmitted: false, submittedEmail: '' }),

        computed: {
            pageTitle() {
                return this.isSubmitted
                    ? this.$t('pages.auth.forgot_password.title_submitted')
                    : this.$t('pages.auth.forgot_password.title')
            },

            pageIcon() {
                return this.isSubmitted ? 'success' : null
            },
        },

        methods: {
            formSubmitted(event) {
                this.submittedEmail = event
                this.isSubmitted = true
            },
        },

        mounted() {
            if (AuthService.isSubdomainActive()) {
                AuthService.reloadSubdomainCompany()
            }
        },
    }
</script>
